import { render } from "./LinksRelTypes.vue?vue&type=template&id=62ae55de"
import script from "./LinksRelTypes.vue?vue&type=script&lang=js"
export * from "./LinksRelTypes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__